import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { useQuery, registerQuery } from 'data-fetching-client';
const AssociatedFormsQuery = registerQuery({
  fieldName: 'forms',
  fetcher: ({
    id
  }) => {
    return http.get('cosindex/api/v1/connections/children', {
      query: {
        childType: 'FORM',
        fields: 'BASIC',
        id,
        levels: 0
      }
    });
  }
});
const useAssociatedForms = contentId => {
  const {
    data,
    loading,
    error
  } = useQuery(AssociatedFormsQuery, {
    variables: {
      id: contentId
    }
  });
  return useMemo(() => ({
    forms: data === null || data === void 0 ? void 0 : data.forms,
    formsLoading: loading,
    formsError: error
  }), [data, loading, error]);
};
export default useAssociatedForms;